import { RouteObject } from "react-router-dom";

const reportsRoutes: RouteObject[] = [
	{
		path: "izvjestaji",
		lazy: () => import("@/pages/Page"),
		children: [
			{
				path: "pisarnica",
				lazy: () => import("@/pages/Reports/RegistryReportsPage")
			},
			{
				path: "statistike",
				lazy: () => import("@/pages/Reports/StatsReportsPage")
			},
			{
				path: "kpu",
				lazy: () => import("@/pages/Reports/KpiReportsPage")
			}
		]
	}
];

export default reportsRoutes;
